//import Timing from './timing/component.vue';

export default {
    //'timing': Timing,
}